import { fetchQueryData } from 'hooks/use-gremlin-query'
import { apiKeysQueryKeys } from 'queries/apikeys/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

import type { QueryFunctionContext } from 'react-query'
import type { ApiKey } from 'types/api/api-key'

export function fetchApiKeysAllForCompany({
  queryKey: [endpoint, { teamId = '' }]
}: QueryFunctionContext<ReturnType<typeof apiKeysQueryKeys.getAllForCompany>>) {
  const endpointWithParams = getEndpointWithParams(endpoint, { teamId })

  return fetchQueryData<ApiKey[]>(endpointWithParams, {})
}
